import type { BreadCrumbJsonLdProps } from 'next-seo';

import { UrlParams } from 'common/url-params';
import { CONFIG } from 'constants/config';
import { isClient } from 'helpers/BrowserHelpers';

import type { IPageUrlParams, TFunction } from 'types';

export const DEFAULT_SEO_IMAGE = [{ url: 'https://cdn.freshful.ro/assets/icon_512.png' }];

export function getCommonListingPageSeoProps(urlParams: IPageUrlParams): {noindex: boolean, canonical: string | undefined} {

  if (!urlParams) {
    return { noindex: true, canonical: undefined };
  }

  const {
    indexable, page, isPaginated, isDefaultCategory, identifier, base
  } = urlParams;

  const isPageCanonicalNeeded = page === 1 && isPaginated;
  const pageCanonicalValue = isPageCanonicalNeeded ? 0 : page;
  const isCategoryCanonicalNeeded = isDefaultCategory;
  const baseCanonicalValue = isCategoryCanonicalNeeded ? identifier : base;
  const isCanonicalNeeded = isPageCanonicalNeeded || isCategoryCanonicalNeeded;
  const canonical = isCanonicalNeeded
    ? `${CONFIG.BASE_URL}${UrlParams.setParams({ ...urlParams, page: pageCanonicalValue, base: baseCanonicalValue })}`
    : undefined;

  return {
    noindex: !indexable,
    canonical
  };
}

export function getPageSeoBreadcrumbs(
  t: TFunction,
  breadcrumbs?: {name: string, slug: string}[],
  options?: {base: string, includesLast: boolean}
) {

  const { base = '', includesLast = false } = options || {};
  const homeBreadcrumb = { position: 1, name: t('NAVIGATION.HOME'), item: CONFIG.BASE_URL };

  if (!breadcrumbs?.length || (includesLast && breadcrumbs.length === 1)) return [homeBreadcrumb];

  try {
    const breadcrumbsArray: BreadCrumbJsonLdProps['itemListElements'] = [];
    let previousBase = `${CONFIG.BASE_URL}${base}`;

    const arr = includesLast ? breadcrumbs.slice(0, -1) : breadcrumbs;
    arr.forEach((breadcrumb, index) => {
      const { name, slug } = breadcrumb;
      previousBase += `${slug.includes('/') ? slug : `/${slug}`}`;
      breadcrumbsArray.push({
        position: index + 2,
        name,
        item: previousBase
      });
    });

    return [
      homeBreadcrumb,
      ...breadcrumbsArray
    ];

  } catch (err) {
    console.error('Failed to create breadcrumbs JSON-LD', err);
  }

  return [];
}

export function getOpenGraphUrl() {
  return isClient() ? window.location.href : CONFIG.BASE_URL;
}

export function getPaginationCanonical(urlParams: IPageUrlParams) {
  const { page, isPaginated } = urlParams;
  return page === 1 && isPaginated ? `${CONFIG.BASE_URL}${UrlParams.setParams({ ...urlParams, page: 0 })}` : undefined;
}
